import AuthPolicies from "@/models/auth/auth-policies";
import { IAuthState } from "./interfaces/auth-state";

export default class AuthState implements IAuthState {
    public policies = new AuthPolicies();
}
